import { render, staticRenderFns } from "./select-invigilator-modal.vue?vue&type=template&id=c101d652"
import script from "./select-invigilator-modal.vue?vue&type=script&lang=ts"
export * from "./select-invigilator-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports